import { HttpClient } from '@angular/common/http';
import { HttpService } from '../http-service/http.service';

import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import * as moment from 'moment';

const BASE_URL_JAVA = environment.BASE_URL_JAVA;

const FETCH_EVENTS_URL = 'booking-service/booking/calendar'
const FETCH_BOOKING_URL = 'booking-service/booking'
const FETCH_TOURNAMENT_URL = 'tournament-service/tournament/my'
const SAVE_TOURNAMENT_URL = 'tournament-service/tournament'
const GET_TOURNAMENT_DETAILS_URL = 'tournament-service/tournament/'
const BALANCE_TRANSFER_CUSTOMERS_URL = 'booking-service/wallet/share/balance'

const SIGNED_URL = 'community/file/signed/url'





@Injectable({
  providedIn: 'root'
})
export class HttpJavaService {
  constructor(private http: HttpService, private httpJava: HttpClient) { }


  getSingleDayBookingsOnline = async (facilityId, date) => {
    const generatedHeaders = await this.http.generateHeadersForJava();
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.get(`${BASE_URL_JAVA}${FETCH_EVENTS_URL}`, {
        params: { facilityId, start: date },
        headers: generatedHeaders,
      })
        .toPromise()
        .then((res) => {
          const data: any = res;
          resolve(data);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
  };


  getSingleBookingDetails = async (bookingId,) => {
    const generatedHeaders = await this.http.generateHeadersForJava();
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.get(`${BASE_URL_JAVA}${FETCH_BOOKING_URL}/${bookingId}`, {

        headers: generatedHeaders,
      })
        .toPromise()
        .then((res) => {
          const data: any = res;
          resolve(data);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
  };


  getAllBookings = async (queryString) => {
    const generatedHeaders = await this.http.generateHeadersForJava();
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.get(`${BASE_URL_JAVA}${FETCH_BOOKING_URL}?${queryString}`, {

        headers: generatedHeaders,
      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Tutorials -----------------//


  createTutorial = async (tutorial: object, country: string) => {
    const dateTime = moment().format('YYYYMMDDHHmmss').toString();
    const generatedHeaders = await this.http.generateHeadersForJava({ 'x-country': country, 'x-datetime': dateTime });
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.post(`${BASE_URL_JAVA}booking-service/tutorial`, tutorial, {
        headers: generatedHeaders,
      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }


  getAllTournaments = async (queryString) => {
    const generatedHeaders = await this.http.generateHeadersForJava();
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.get(`${BASE_URL_JAVA}${FETCH_TOURNAMENT_URL}?${queryString}`, {

        headers: generatedHeaders,
      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getSignedURLS3 = async (fileExt, contentType) => {
    const obj = {
      fileExt: fileExt,
      contentType: contentType,
    }

    const params = new URLSearchParams(obj as any);
    const queryString = params.toString();
    const generatedHeaders = await this.http.generateHeadersForJava();
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.get(`${BASE_URL_JAVA}${SIGNED_URL}?${queryString}`, {
        headers: generatedHeaders,
      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateTutorial = async (tutorial, country) => {
    const dateTime = moment().format('YYYYMMDDHHmmss').toString();
    const generatedHeaders = await this.http.generateHeadersForJava({ 'x-country': country, 'x-datetime': dateTime });
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.put(`${BASE_URL_JAVA}booking-service/tutorial/${tutorial?.id}`, tutorial, {
        headers: generatedHeaders,
      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }


  uploadImageFileToS3 = async (uploadURL, file) => {

    const generatedHeaders = await this.http.generateHeadersForJava();
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.put(`${uploadURL}`, file, {
        headers: generatedHeaders,
      })
        .toPromise()
        .then(res => {
          const data: any = res;

          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }



  saveNewTournament = async (tournamentData) => {
    const generatedHeaders = await this.http.generateHeadersForJava();
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.post(`${BASE_URL_JAVA}${SAVE_TOURNAMENT_URL}`, tournamentData, {

        headers: generatedHeaders,

      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //
  //
  // https://4e01-39-55-187-144.ngrok-free.app/tournament/${id}
  updateExistingTournament = async (tournamentData, id) => {
    const generatedHeaders = await this.http.generateHeadersForJava();
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.put(`${BASE_URL_JAVA}${SAVE_TOURNAMENT_URL}/${id}`, tournamentData, {

        headers: generatedHeaders,

      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  balanceShareBetweenCustomers = async (balanceTransferPayload) => {
    const generatedHeaders = await this.http.generateHeadersForJava();
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.post(`${BASE_URL_JAVA}${BALANCE_TRANSFER_CUSTOMERS_URL}`, balanceTransferPayload, {

        headers: generatedHeaders,

      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }


  searchUserDashboard = async (searchQuery: string) => {
    const generatedHeaders = await this.http.generateHeadersForJava();
    const url = `${BASE_URL_JAVA}booking-service/user/dashboard/search?q=${encodeURIComponent(searchQuery)}`;

    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.get(url, {
        headers: generatedHeaders,
      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  };


  getCompleteTournamentDetails = async (tournamentID) => {
    const generatedHeaders = await this.http.generateHeadersForJava();
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.get(`${BASE_URL_JAVA}${GET_TOURNAMENT_DETAILS_URL}${tournamentID}`, {
        headers: generatedHeaders,
      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }


  deleteTutorial = async (tutorialId, country) => {
    const dateTime = moment().format('YYYYMMDDHHmmss').toString();
    const generatedHeaders = await this.http.generateHeadersForJava({ 'x-country': country, 'x-datetime': dateTime });
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.delete(`${BASE_URL_JAVA}booking-service/tutorial/${tutorialId}`, {
        headers: generatedHeaders,
      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  saveNewTournamentCategory = async (categoryData, tournamentID) => {
    const generatedHeaders = await this.http.generateHeadersForJava();
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.post(`${BASE_URL_JAVA}${GET_TOURNAMENT_DETAILS_URL}${tournamentID}/category`, categoryData, {
        headers: generatedHeaders,
      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getAllTutorials = async (country) => {
    const generatedHeaders = await this.http.generateHeadersForJava({ 'x-country': country });
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.get(`${BASE_URL_JAVA}booking-service/tutorial`, {
        headers: generatedHeaders,
      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateNewTournamentCategory = async (categoryData, tournamentID, categoryID) => {
    const generatedHeaders = await this.http.generateHeadersForJava();
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.put(`${BASE_URL_JAVA}${GET_TOURNAMENT_DETAILS_URL}${tournamentID}/category/${categoryID}`, categoryData, {
        headers: generatedHeaders,
      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteTournamentCategory = async (tournamentID, categoryID) => {
    const generatedHeaders = await this.http.generateHeadersForJava();
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.delete(`${BASE_URL_JAVA}${GET_TOURNAMENT_DETAILS_URL}${tournamentID}/category/${categoryID}`, {
        headers: generatedHeaders,
      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getCategoryList = async (queryString, tournamentID) => {
    const generatedHeaders = await this.http.generateHeadersForJava();
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.get(`${BASE_URL_JAVA}${GET_TOURNAMENT_DETAILS_URL}${tournamentID}/category?${queryString}`, {
        headers: generatedHeaders,
      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getPaymentList = async (queryString, tournamentID) => {
    const generatedHeaders = await this.http.generateHeadersForJava();
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.get(`${BASE_URL_JAVA}${GET_TOURNAMENT_DETAILS_URL}${tournamentID}/payment/method?${queryString}`, {
        headers: generatedHeaders,
      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteTournamentPayment = async (tournamentID, paymentID) => {
    const generatedHeaders = await this.http.generateHeadersForJava();
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.delete(`${BASE_URL_JAVA}${GET_TOURNAMENT_DETAILS_URL}${tournamentID}/payment/method/${paymentID}`, {
        headers: generatedHeaders,
      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  saveNewTournamentPayment = async (paymentData, tournamentID) => {
    const generatedHeaders = await this.http.generateHeadersForJava();
    return new Promise<any>(async (resolve, reject) => {
      await this.httpJava.post(`${BASE_URL_JAVA}${GET_TOURNAMENT_DETAILS_URL}${tournamentID}/payment/method`, paymentData, {
        headers: generatedHeaders,
      })
        .toPromise()
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  async uploadSignedFile(file: File): Promise<string> {
    const contentType = file.type;
    const fileNameParts = file.name.split('.');
    const fileExtension = fileNameParts.length > 1 ? fileNameParts.pop() : '';
    const generatedHeaders = await this.http.generateHeadersForJava();

    const fileUploadPath = await new Promise<string>((resolve, reject) => {
      const url = `${BASE_URL_JAVA}community/file/signed/url?contentType=${contentType}&fileExt=${fileExtension}`;
      this.httpJava.get(url, { headers: generatedHeaders })
        .subscribe({
          next: (res: any) => {
            resolve(res.data.content);
          },
          error: (err) => {
            reject(err);
          }
        });
    });

    const fileUrl = fileUploadPath.split('?')[0];

    await new Promise<void>((resolve, reject) => {
      const headers = generatedHeaders.set('Content-Type', contentType);
      this.httpJava.put(fileUploadPath, file, { headers })
        .subscribe({
          next: (res: any) => {
            resolve();
          },
          error: (err) => {
            reject(err);
          }
        });
    });

    return fileUrl;
  }



}

